export default __webpack_public_path__ + "static/media/mt.db60e9a1.png";